import React, { useState, useEffect } from 'react';

function Typewriter({ texts, speed = 100, deleteSpeed = 50, delay = 1500 }) {
  const [displayedText, setDisplayedText] = useState('');
  const [index, setIndex] = useState(0);
  const [phase, setPhase] = useState('typing'); // 'typing' or 'deleting'
  const [textIndex, setTextIndex] = useState(0);

  useEffect(() => {
    if (phase === 'typing') {
      if (index < texts[textIndex].length) {
        const timer = setTimeout(() => {
          setDisplayedText(displayedText + texts[textIndex][index]);
          setIndex(index + 1);
        }, speed);
        return () => clearTimeout(timer);
      } else {
        const delayTimer = setTimeout(() => {
          setPhase('deleting');
        }, delay);
        return () => clearTimeout(delayTimer);
      }
    } else if (phase === 'deleting') {
      if (index > 2) {
        const timer = setTimeout(() => {
          setDisplayedText(displayedText.slice(0, -1));
          setIndex(index - 1);
        }, deleteSpeed);
        return () => clearTimeout(timer);
      } else {
        const delayTimer = setTimeout(() => {
          setPhase('typing');
          setTextIndex((textIndex + 1) % texts.length);
        }, delay);
        return () => clearTimeout(delayTimer);
      }
    }
  }, [index, phase, textIndex, displayedText, texts, speed, deleteSpeed, delay]);

  return <div>{displayedText}</div>;
}

export default Typewriter;

/* function App() {
  const texts = [
    "Bienvenue sur mon site !",
    "Je suis développeur React.",
    "Voici un effet de typewriter."
  ];

  return (
    <div>
      <h1>
        <Typewriter texts={texts} speed={100} deleteSpeed={50} delay={1000} />
      </h1>
    </div>
  );
}

export default App;
 */